var u = Object.defineProperty;
var h = (a, t, e) => t in a ? u(a, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : a[t] = e;
var s = (a, t, e) => h(a, typeof t != "symbol" ? t + "" : t, e);
var d = (a, t, e) => new Promise((r, o) => {
  var f = (i) => {
    try {
      c(e.next(i));
    } catch (l) {
      o(l);
    }
  }, p = (i) => {
    try {
      c(e.throw(i));
    } catch (l) {
      o(l);
    }
  }, c = (i) => i.done ? r(i.value) : Promise.resolve(i.value).then(f, p);
  c((e = e.apply(a, t)).next());
});
const n = (a, t, ...e) => {
  const r = `[@launchdarkly plugins]: (${a}): `;
  console[t].apply(console, [r, ...e]), _(r, ...e);
}, _ = (a, ...t) => d(void 0, null, function* () {
  try {
    const { LDObserve: e } = yield import("./LDObserve.js");
    e.recordLog(`${a}${t}`, "warn");
  } catch (e) {
  }
});
class g {
  constructor(t, e) {
    s(this, "debug");
    s(this, "name");
    this.debug = t, this.name = e;
  }
  log(...t) {
    if (this.debug) {
      let e = `[${Date.now()}]`;
      this.name && (e += ` - ${this.name}`), console.log.apply(console, [e, ...t]);
    }
  }
  warn(...t) {
    let e = `[${Date.now()}]`;
    this.name && (e += ` - ${this.name}`), console.warn.apply(console, [e, ...t]);
  }
}
class x {
  constructor() {
    s(this, "_sdk");
    s(this, "_isLoaded", !1);
    s(this, "_callBuffer", []);
    s(this, "_capacity", 1e5);
    s(this, "_droppedEvents", 0);
    s(this, "_exceededCapacity", !1);
    s(this, "_logger", new g());
  }
  _bufferCall(t, e) {
    if (this._isLoaded)
      try {
        return this._sdk[t](...e);
      } catch (r) {
        n(
          `Error executing buffered call to ${t}:`,
          "error",
          r
        );
      }
    else {
      this._enqueue({ method: t, args: e });
      return;
    }
  }
  _enqueue(t) {
    this._callBuffer.length < this._capacity ? (this._callBuffer.push(t), this._exceededCapacity = !1) : (this._exceededCapacity || (this._exceededCapacity = !0, n(
      "Exceeded event queue capacity. Increase capacity to avoid dropping events.",
      "warn"
    )), this._droppedEvents += 1);
  }
  load(t) {
    this._sdk = t, this._isLoaded = !0;
    for (const { method: e, args: r } of this._callBuffer)
      try {
        this._sdk[e](...r);
      } catch (o) {
        n(
          `Error executing buffered call to ${e}:`,
          "error",
          o
        );
      }
    this._callBuffer = [];
  }
}
export {
  x as B,
  g as L,
  n as i
};
//# sourceMappingURL=buffer-BNTl5fQI.js.map
